import React from 'react';
import styled from 'styled-components'

import PageHeading from './PageHeading'
import FadeIn from './FadeIn'

import { device } from '../media'

const PurposeContainer = styled.div`
  display: ${props => props.mobileDisplay};
  @media ${device.mobile} {
    display: block;
  }
`

class Purpose extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileDisplay: ''
    }
  }

  componentWillMount = () => {
    // trick needed to avoid error: WebpackError: window is not defined
    const windowGlobal = typeof window !== 'undefined' && window
    if (windowGlobal && windowGlobal.location.pathname === '/') {
      this.setState({ mobileDisplay: 'block' })
    } else {
      this.setState({ mobileDisplay: 'none' })
    }
  }

  render() {
    return (
      <PurposeContainer mobileDisplay={this.state.mobileDisplay}>
        <PageHeading>Our purpose is</PageHeading>
        <p style={{marginBottom: 0}}>To accelerate people’s potential so they can make their mark.</p>
      </PurposeContainer>
    )
  }
}

export default Purpose



// WEBPACK FOOTER //
// ./src/components/Purpose.js